import { z } from 'zod';

export const PropertySchema = z.object({
	name: z
		.string()
		.min(1, 'Nome é obrigatório')
		.max(140, 'Nome deve ter no máximo 140 caracteres'),
	state: z.string().min(1, 'Estado é obrigatório'),
	subscription: z
		.string()
		.max(300, 'Inscrição deve ter no máximo 300 caracteres')
		.optional()
		.or(z.literal('')),
	cep: z
		.string()
		.min(1, 'CEP é obrigatório')
		.refine(v => /^\d{2}\.\d{3}-\d{3}$/.test(v), 'CEP inválido (ex.: 12.345-678)'),
	city: z.string().max(150, 'Cidade deve ter no máximo 150 caracteres').optional().or(z.literal('')),
	street: z
		.string()
		.max(150, 'Logradouro deve ter no máximo 150 caracteres')
		.optional()
		.or(z.literal('')),
	district: z
		.string()
		.max(150, 'Bairro deve ter no máximo 150 caracteres')
		.optional()
		.or(z.literal('')),
	number: z.string().optional().or(z.literal('')),
});

export type PropertySchemaType = z.infer<typeof PropertySchema>;
